export default "__VITE_ASSET__B9V03$6p__"